var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDynamicRouting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.68 14.6H19.07C20.96 14.6 22.49 13.07 22.49 11.18C22.49 9.5 21.27 8.1 19.67 7.82C19.68 7.65 19.7 7.48 19.7 7.31C19.7 4.1 17.1 1.51 13.9 1.51C11.02 1.51 8.64 3.61 8.18 6.35C8.16 6.38 8.14 6.42 8.13 6.45C7.92 6.35 7.71 6.27 7.48 6.23C5.62 5.87 4.02 7.47 4.37 9.33C2.64 9.18 1.21 10.71 1.55 12.48C1.75 13.52 2.59 14.36 3.63 14.56C3.72 14.58 3.81 14.59 3.9 14.59L3.88 14.6C3.9 14.6 7.88 14.6 7.89 14.6",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 12.47V18.14H17.21",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.11 12.47V18.14H8.45001",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.23 12.52V19.96",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.54 17.34C18.99 17.34 19.35 17.7 19.35 18.15C19.35 18.6 18.99 18.96 18.54 18.96C18.09 18.96 17.73 18.6 17.73 18.15C17.73 17.7 18.1 17.34 18.54 17.34ZM18.54 16.34C17.54 16.34 16.73 17.15 16.73 18.15C16.73 19.15 17.54 19.96 18.54 19.96C19.54 19.96 20.35 19.15 20.35 18.15C20.35 17.15 19.54 16.34 18.54 16.34Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12 17.19C7.57 17.19 7.93 17.55 7.93 18C7.93 18.45 7.57 18.81 7.12 18.81C6.67 18.81 6.31 18.44 6.31 18C6.31 17.55 6.67 17.19 7.12 17.19ZM7.12 16.19C6.12 16.19 5.31 17 5.31 18C5.31 19 6.12 19.81 7.12 19.81C8.12 19.81 8.93 19 8.93 18C8.93 17 8.11 16.19 7.12 16.19Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.23 20.6C12.68 20.6 13.04 20.96 13.04 21.41C13.04 21.86 12.68 22.22 12.23 22.22C11.78 22.22 11.42 21.86 11.42 21.41C11.42 20.96 11.78 20.6 12.23 20.6ZM12.23 19.6C11.23 19.6 10.42 20.41 10.42 21.41C10.42 22.41 11.23 23.22 12.23 23.22C13.23 23.22 14.04 22.41 14.04 21.41C14.04 20.41 13.22 19.6 12.23 19.6Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45001 12.29H15.82",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDynamicRouting);
export default __webpack_public_path__ + "static/media/icon-dynamic-routing.50090cd2.svg";
export { ForwardRef as ReactComponent };